import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import Title from "../Title/Title";
import "swiper/css";
import "swiper/css/navigation";
import "./TopCategories.css";

export default function CategorySwiper({ categories }) {
  return (
    <div >
      <Title title='Shop by Category' />
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={20}
        slidesPerView={4}
        navigation={true}
        loop={true}
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 10 },
          640: { slidesPerView: 3, spaceBetween: 15 },
          1024: { slidesPerView: 4, spaceBetween: 20 },
          1440: { slidesPerView: 5, spaceBetween: 25 },
        }}
        className="custom-swiper"
      >
        {categories.map((cat, index) => (
          <SwiperSlide key={index}>
            <Link
              to={`/${cat.category}/${cat.slug}`}
              className="category-card-link"
            >
              <div className="category-card">
                <div className="category-image">
                  <img src={cat.image} alt={cat.name} />
                </div>
                <div className="category-info">
                  <h3>{cat.name}</h3>
                  <span className="arrow">›</span>
                </div>
              </div>
            </Link>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}